export class JobPostingSite {
  id?: number;
  version?: number;

  name: string;
  contact: string;
  url: string;
  username: string;
  password: string;
  contactEmail: string;
  contactPhone: string;
  orgId?: number;
}
